import React from "react";
import SubmissionFormsTable from "../components/forms/SubmissionFormsTable";

const MaagarSubmissionsTable: React.FC = () => (
  <SubmissionFormsTable
    apiSegment="maagar-submissions"
    title="טבלת הגשות טופס מאגר"
    emptyLabel="אין הגשות מאגר להצגה"
    formPageUrl="https://rafael-car-show.co.il/maagar-form"
  />
);

export default MaagarSubmissionsTable;
